import { RouterState, RouterStore } from "mobx-state-router";
import { AppStore } from "./app.store";
import { AuthStore } from "./auth.store";

import { routes } from "./routes";
import { CodeMapStore } from "features/code-map/stores/code.map.store";

const notFound = new RouterState("notFound");

export class RootStore {
  appStore = new AppStore(this);
  authStore = new AuthStore(this);
  codeMapStore = new CodeMapStore(this);

  routerStore = new RouterStore(this, routes, notFound);
}
